import { ability } from '@/plugins/casl/ability'
import { canNavigate } from '@layouts/plugins/casl'

export const setupGuards = router => {
  router.beforeEach(to => {
    const subject = to.meta?.subject

    // ✅ Use raw ability directly
    const can = ability.can.bind(ability)

    if (subject && !can('read', subject)) {
      return { name: 'not-authorized' }
    }

    if (to.meta.public) return

    const isLoggedIn = !!(useCookie('userData').value && useCookie('accessToken').value)

    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn)
        return '/'
      else
        return undefined
    }

    if (!canNavigate(to) && to.matched.length) {
      return isLoggedIn
        ? { name: 'not-authorized' }
        : {
            name: 'login',
            query: {
              ...to.query,
              to: to.fullPath !== '/' ? to.path : undefined,
            },
          }
    }
  })
}
